import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import Banner from '../img/StaffHero.jpg';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default () => {
  const data = useStaticQuery(graphql`
    query {
      Banner: file(relativePath: { eq: "StaffHero.jpg" }) {
        childImageSharp {
          # Specify a fluid image and fragment
          # The default maxWidth is 800 pixels
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Andy: file(relativePath: { eq: "AndyMcDonald.jpg" }) {
        childImageSharp {
          # Specify a fluid image and fragment
          # The default maxWidth is 800 pixels
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <div className="antialiased text-gray-900 min-h-screen flex flex-col">
      <Navbar />
      <div className="overflow-hidden" style={{ height: '19rem' }}>
        <Img
          fluid={data.Banner.childImageSharp.fluid}
          imgStyle={{
            objectFit: 'cover',
            objectPosition: '50% 60%',
            height: '19rem',
          }}
        />
      </div>
      <main className="flex-grow">
        <div className="max-w-screen-md mx-auto mb-12 px-12">
          <h1 className="text-center font-bold text-4xl mt-4">Staff</h1>
          <h2>Director</h2>
          <p>
            <Img
              fluid={data.Andy.childImageSharp.fluid}
              alt=""
              className="w-1/3 float-right ml-4 mt-2"
            />
            <strong>Andy McDonald</strong> has been working to address climate
            change and sustainability for 30 years. From 2004&ndash;2012, he was
            the Director of the Kentucky Solar Partnership for
            Appalachia-Science in the Public Interest. In 2013, he joined Earth
            Tools and established our Sustainable Systems Program and in 2020,
            he founded Apogee &ndash; Climate & Energy Transitions.
          </p>
          <p>
            Andy’s work experience includes solar energy system design and
            installation; state and local energy policy; educational outreach
            program development; writing and public speaking; and the
            development of demonstration projects.
          </p>
          <p>
            Andy participated in the development of Kentucky’s net metering law
            and statewide interconnection guidelines. He has participated in
            cases before the Public Service Commission, testified before
            Legislative committees, worked with legislators drafting
            legislation, written both technical and public-education documents
            on energy policy issues, and presented numerous lectures on solar
            energy and climate change. He is the co-author with Joshua Bills of
            The Kentucky Solar Energy Guide (2004).
          </p>
          <p>
            Andy has been involved in the design and construction of numerous
            energy efficient homes utilizing solar energy and other green
            building strategies. This includes his own home, a net-zero-energy
            renovated farmhouse featuring passive solar design, a 2 KW solar PV
            system, and solar water heating.
          </p>
          <p>
            Andy has an M.Sc. in Sustainable Systems from Slippery Rock
            University of Pennsylvania and a B.A. in Philosophy from the
            University of Buffalo.
          </p>

          <p>
            CONTACT
            <br />
            Apogee &ndash; Climate & Energy Transitions <br />
            316 Wapping St., Suite 204 <br />
            Frankfort, KY 40601 <br />
            502-699-2553 office <br />
            <a href="mailto:andy@apogeeclimage.org">andy@ApogeeClimate.org</a>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};
